<template>
<div class="center__div">
  <vue-headful :title="site_title + ': ' + pagetitle" />
  <template v-if="displayNews">
    <div class="news__news" v-if="displayTitle && pageReady">{{pagetitle}}</div>
    <MainStickiedArticles />
  </template>

  <div v-if="findArticlesByUser && pageReady">
    <div class="sidepanel__link" v-for="item in this.data.items">
      <div><img src="/p.gif" /></div>
      <div><a :href="'/main/?actions=viewarticles&page=' + item.id">{{decodeHtml(item.header)}}</a> (<b>{{item.ncomments}}</b>)</div>
    </div>
  </div>

  <div v-if="findNewsByUser && pageReady">
    <div class="sidepanel__link" v-for="item in this.data.items">
      <div><img src="/p.gif" /></div>
      <div><a :href="'/main/?actions=viewnews&page=' + item.id">{{decodeHtml(item.header)}}</a> (<b>{{item.ncomments}}</b>)</div>
    </div>
  </div>

  <div v-if="listArticleSections && pageReady">
    <div class="sidepanel__link" v-for="item in this.data.items">
      <div><img src="/p.gif" /></div>
      <div><a :href="'/main/?actions=articles&sections=' + item.section">{{decodeHtml(item.name)}}</a> (<b>{{item.articles}}</b>)</div>
    </div>
  </div>

  <div v-if="listArticleCategories && pageReady">
    <div class="sidepanel__link" v-for="item in this.data.items">
      <div><img src="/p.gif" /></div>
      <div><a :href="'/main/?actions=articles&sections=' + item.section + '&category=' + item.cat">{{decodeHtml(item.name)}}</a> (<b>{{item.articles}}</b>)</div>
    </div>
  </div>

  <div v-if="listArticlesByCategory && pageReady">
    <div class="sidepanel__link" v-for="item in this.data.items">
      <div><img src="/p.gif" /></div>
      <div><a :href="'/main/?actions=viewarticles&page=' + item.id">{{decodeHtml(item.header)}}</a> (<b>{{item.ncomments}}</b>)</div>
    </div>
  </div>

  <div v-if="displayNewsCategories">
    <div class="sidepanel__link">
      <div><img src="/p.gif" /></div>
      <div><a href="/main/?actions=news&category=1">Neverwinter Nights</a> (<b>144</b>)</div>
    </div>
    <div class="sidepanel__link">
      <div><img src="/p.gif" /></div>
      <div><a href="/main/?actions=news&category=2">Neverwinter Nights: Shadows of Undrentide</a> (<b>79</b>)</div>
    </div>
    <div class="sidepanel__link">
      <div><img src="/p.gif" /></div>
      <div><a href="/main/?actions=news&category=3">Neverwinter Nights: Hordes of the Underdark</a> (<b>146</b>)</div>
    </div>
    <div class="sidepanel__link">
      <div><img src="/p.gif" /></div>
      <div><a href="/main/?actions=news&category=4">World of WarCraft</a> (<b>63</b>)</div>
    </div>
    <div class="sidepanel__link">
      <div><img src="/p.gif" /></div>
      <div><a href="/main/?actions=news&category=5">Dungeons & Dragons</a> (<b>64</b>)</div>
    </div>
    <div class="sidepanel__link">
      <div><img src="/p.gif" /></div>
      <div><a href="/main/?actions=news&category=5">Dungeons & Dragons</a> (<b>64</b>)</div>
    </div>
    <div class="sidepanel__link">
      <div><img src="/p.gif" /></div>
      <div><a href="/main/?actions=news&category=6">Lionheart</a> (<b>31</b>)</div>
    </div>
    <div class="sidepanel__link">
      <div><img src="/p.gif" /></div>
      <div><a href="/main/?actions=news&category=7">The Temple of Elemental Evil</a> (<b>74</b>)</div>
    </div>
    <div class="sidepanel__link">
      <div><img src="/p.gif" /></div>
      <div><a href="/main/?actions=news&category=8">Dungeons & Dragons Online</a> (<b>8</b>)</div>
    </div>
    <div class="sidepanel__link">
      <div><img src="/p.gif" /></div>
      <div><a href="/main/?actions=news&category=9">Realms.Ru</a> (<b>34</b>)</div>
    </div>
    <div class="sidepanel__link">
      <div><img src="/p.gif" /></div>
      <div><a href="/main/?actions=news&category=10">Axistown</a> (<b>78</b>)</div>
    </div>
    <div class="sidepanel__link">
      <div><img src="/p.gif" /></div>
      <div><a href="/main/?actions=news&category=18">Dragon Age</a> (<b>11</b>)</div>
    </div>
    <div class="sidepanel__link">
      <div><img src="/p.gif" /></div>
      <div><a href="/main/?actions=news&category=28">Neverwinter Nights 2</a> (<b>20</b>)</div>
    </div>
    <div class="sidepanel__link">
      <div><img src="/p.gif" /></div>
      <div><a href="/main/?actions=news&category=29">Gothic III</a> (<b>2</b>)</div>
    </div>
    <div class="sidepanel__link">
      <div><img src="/p.gif" /></div>
      <div><a href="/main/?actions=news&category=30">The Witcher</a> (<b>2</b>)</div>
    </div>
  </div>

</div>
</template>

<script>
import MainStickiedArticles from './MainStickiedArticles'
//import FooterPermanent from './FooterPermanent'

export default {
  props: ['displayNewsCategories', 'listArticleSections', 'listArticleCategories', 'listArticlesByCategory', 'findArticlesByUser', 'findNewsByUser'], // passed from Main.vue
  components: {
    MainStickiedArticles,
    //ForumSection,
    //FooterPermanent
  },
  data: function() {
    return {
      displayNews: true,
      pageReady: false,
      pagetitle: "",
      displayTitle: true,
      data: null,
    }
  },
  async created() {

    console.time("PageLoadTime");
    let response = null;

    if (this.displayNewsCategories) {
      this.pagetitle = "Новости";
      this.pageReady = true;
      return;
    } else if (this.listArticleSections) {
      response = await fetch(this.getNodePath() + 'main/articles/');
      this.pagetitle = "Статьи";
    } else if (this.listArticleCategories) {
      let section = 0;
      if (this.$route.query.sections)
        section = this.$route.query.sections;
      else if (this.$route.query.ions)
        section = this.$route.query.ions;
      response = await fetch(this.getNodePath() + 'main/articles/' + section);

    } else if (this.listArticlesByCategory) {
      let category = 0;
      if (this.$route.query.category)
        category = this.$route.query.category;
      // if we've got a category, we don't need a section, just feed in zero
      response = await fetch(this.getNodePath() + 'main/articles/0/category/' + category);
      //this.pagetitle = "Раздел ..., Ярус ...";
    } else if (this.findArticlesByUser) {
      let userId = 0;
      if (this.$route.query.user)
        userId = this.$route.query.user;
      response = await fetch(this.getNodePath() + 'main/findarticles/' + userId);
    } else if (this.findNewsByUser) {
      let userId = 0;
      if (this.$route.query.user)
        userId = this.$route.query.user;
      response = await fetch(this.getNodePath() + 'main/findnews/' + userId);
    }

    this.data = await response.json();

    if (this.listArticleCategories)
      this.pagetitle = "Раздел " + this.data.section;
    else if (this.listArticlesByCategory)
      this.pagetitle = "Раздел " + this.data.section + ", ярус " + this.data.category;
    else if (this.findArticlesByUser)
      this.pagetitle = "Статьи от " + this.decodeHtml(this.data.user);
    else if (this.findNewsByUser)
      this.pagetitle = "Новости от " + this.decodeHtml(this.data.user);

    this.pageReady = true;
    console.timeEnd("PageLoadTime");
  },
  methods: {
    test() {}
  }
}
</script>

<style lang="scss">
@import "../main-colors.scss";
@import "./MainNews.scss";
</style>
